import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { RequestBuilder } from '@hereisyourgitanton/crm-api2';
import { TradingProcedureDocumentResponseDto } from '../schemas/trading-procedure-document-response.dto';
import { TradingProcedureRegistryInfoResponseDto } from '../schemas/trading-procedure-registry-info-response.dto';
import { UploadTradingProcedureRegistryRequestDto } from '../schemas/upload-trading-procedure-registry-request.dto';
import {
    UploadTradingProcedureDocumentRequestDto
} from '../schemas/upload-trading-procedure-document-request.dto';
import {
    LinkTradingProcedureDocumentRequestDto
} from '../schemas/link-trading-procedure-document-request.dto';
import { TRADGINE_DATA_API_BASE_URL } from '../api-base-url.token';

@Injectable({ providedIn: 'root' })
export class TradingProcedureDocumentAdminApi {
    private readonly builder = new RequestBuilder(inject(HttpClient));
    private readonly controllerUrl = `${inject(TRADGINE_DATA_API_BASE_URL)}/TradingProcedureDocumentAdmin`;

    getAll(tradingProcedureId: number) {
        return this.builder
            .url(`${this.controllerUrl}/GetAll`)
            .get()
            .json<TradingProcedureDocumentResponseDto[]>()
            .withHttpParams(new HttpParams().set('tradingProcedureId', tradingProcedureId))
            .build()
            .send();
    }

    getById(tradingProcedureDocumentId: number) {
        return this.builder
            .url(`${this.controllerUrl}/GetById`)
            .get()
            .json<TradingProcedureDocumentResponseDto>()
            .withHttpParams(new HttpParams().set('id', tradingProcedureDocumentId))
            .build()
            .send();
    }

    upload(file: File, request: UploadTradingProcedureDocumentRequestDto) {
        const formData = new FormData();
        formData.append('file', file);
        formData.append('tradingProcedureId', String(request.tradingProcedureId));

        if (request.description != null) {
            formData.append('description', request.description);
        }

        if (request.name != null) {
            formData.append('name', request.name);
        }

        return this.builder
            .url(`${this.controllerUrl}/Upload`)
            .post(formData)
            .json<TradingProcedureDocumentResponseDto>()
            .build()
            .send();
    }

    linkFromOrganization(payload: LinkTradingProcedureDocumentRequestDto) {
        return this.builder
            .url(`${this.controllerUrl}/LinkFromOrganization`)
            .post(payload)
            .json<TradingProcedureDocumentResponseDto>()
            .build()
            .send();
    }

    delete(tradingProcedureDocumentId: number) {
        return this.builder
            .url(`${this.controllerUrl}/Delete`)
            .delete()
            .text()
            .withHttpParams(new HttpParams().set('id', tradingProcedureDocumentId))
            .build()
            .send();
    }

    getRegistryInfo(tradingProcedureId: number) {
        return this.builder
            .url(`${this.controllerUrl}/GetRegistryInfo`)
            .get()
            .json<TradingProcedureRegistryInfoResponseDto>()
            .withHttpParams(new HttpParams().set('tradingProcedureId', tradingProcedureId))
            .build()
            .send();
    }

    getRegistry(tradingProcedureId: number) {
        return this.builder
            .url(`${this.controllerUrl}/GetRegistry`)
            .get()
            .blob()
            .withHttpParams(new HttpParams().set('tradingProcedureId', tradingProcedureId))
            .build()
            .send();
    }

    uploadRegistry(file: File, request: UploadTradingProcedureRegistryRequestDto) {
        const formData = new FormData();
        formData.append('file', file);
        formData.append('tradingProcedureId', String(request.tradingProcedureId));

        if (request.description != null) {
            formData.append('description', request.description);
        }

        if (request.name != null) {
            formData.append('name', request.name);
        }

        return this.builder
            .url(`${this.controllerUrl}/UploadRegistry`)
            .put(formData)
            .json<TradingProcedureRegistryInfoResponseDto>()
            .build()
            .send();
    }

    deleteRegistry(tradingProcedureId: number) {
        return this.builder
            .url(`${this.controllerUrl}/DeleteRegistry`)
            .delete()
            .text()
            .withHttpParams(new HttpParams().set('tradingProcedureId', tradingProcedureId))
            .build()
            .send();
    }
}
